import React, { Component } from 'react';

import { track } from 'utils/analytics';

import './index.css';
export default class Product extends Component {
	state = {
		startX: null
	};

	render() {
		const { productClickUrl, productBrandName, productImageUrl, productName, productPrice } = this.props;
		const { startX } = this.state;

		return (
			<div className="product" onMouseDown={e => {
				e.persist();
				this.setState(() => ({ startX: e.pageX }))}
			}
			onMouseUp={e => {
				const endX = e.pageX;
				console.log(startX, endX);
				if (startX >= (endX - 10) && startX <= (endX + 10)) {
					track('clicked', `buy product - ${productName.replace(/<\/?[^>]+(>|$)/g, ' ')}`);
					window.open(productClickUrl, '_blank');
				}
			}}>
				<img className="image" alt="product" src={productImageUrl} />
				<div className="copy">
					<div className="varied">
						<div className="name">{productBrandName}</div>
						<div className="description">{productName}</div>
					</div>
					<div className="price">{productPrice}</div>
					<div className="cta">BUY</div>
				</div>
			</div>
		);
	}
};



// WEBPACK FOOTER //
// ./src/components/Results/Product/index.js